"use client";

import React from "react";
import AccordionItemFilter from "@/components/AccordionItemFilter";
import { useRouter } from "next/navigation";

export default function GGSFacultyFilters({
  primarySpecialty,
  secondarySpecialty,
  classroom,
  studio,
}) {
  const router = useRouter();

  const filterItems = (filterName, filterValue) => {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    let fq = urlParams.get("fq") || "";

    let currentParams =
      window.location.href.split("?").length > 1
        ? window.location.href
            .split("?")[1]
            .replace(/&fq=.*?(?=&|$)/g, "")
            .replace(/fq=.*?(?=&|$)/g, "")
        : "";
    if (currentParams.startsWith("&")) {
      currentParams = currentParams.substring(1);
    }
    if (!fq.includes(`${filterName}||${filterValue}`)) {
      fq += (fq === "" ? "" : ";") + `${filterName}||${filterValue}`;
    }

    CloseFilters();
    router.push(
      "?" + currentParams + (currentParams != "" ? "&" : "") + `fq=${fq}`
    );
  };

  const CloseFilters = () => {
    const filter = document.getElementById("AWS_Facets");
    const overlay = document.getElementsByClassName("js-off-canvas-overlay")[1];
    const filterButton = document.getElementById("filterButton");

    filter.classList.add("is-closed");
    filter.classList.remove("is-open");
    filter.attributes["aria-hidden"].value = "true";
    filterButton.attributes["aria-expanded"].value = "false";
    overlay.classList.remove("is-visible");
    overlay.classList.remove("is-closable");
  };

  return (
    <div className="cell small-12 xlarge-3 tps-aside-menu">
      <div
        className="off-canvas in-canvas-for-xlarge position-left tps-aws-facets-wrapper tps-aws-facets-off-canvas is-transition-overlap is-closed"
        id="AWS_Facets"
        data-off-canvas=""
        aria-hidden="false"
        data-n="vq05xy-n"
        data-breakpoint="andbeyond"
      >
        <button
          type="button"
          className="hide-for-xlarge"
          data-close=""
          aria-expanded="true"
          onClick={() => CloseFilters()}
        >
          <span className="fal fa-times" aria-hidden="true"></span>
          <span className="sr-only">Close</span>
        </button>

        <h4>Filter Results</h4>

        <ul
          id="tps-aws-facet-list"
          className="accordion"
          data-accordion=""
          data-allow-all-closed="true"
          data-multi-expand="true"
          data-slide-speed="0"
          role="tablist"
          data-i="y83rsj-i"
        >
          {primarySpecialty.length > 0 && (
            <AccordionItemFilter
              key={0}
              index={0}
              title="Primary Specialty"
              items={primarySpecialty.sort((a, b) =>
                a.item_name.localeCompare(b.item_name)
              )}
              id={0}
              itemId="ggs_primary_specialties"
              open={true}
              handleFilter={filterItems}
            />
          )}
          {secondarySpecialty.length > 0 && (
            <AccordionItemFilter
              key={1}
              index={1}
              title="Secondary Specialty"
              items={secondarySpecialty.sort((a, b) =>
                a.item_name.localeCompare(b.item_name)
              )}
              id={1}
              itemId="ggs_secondary_specialties"
              open={true}
              handleFilter={filterItems}
            />
          )}
          {classroom.length > 0 && (
            <AccordionItemFilter
              key={2}
              index={2}
              title="Classroom"
              items={classroom.sort((a, b) =>
                a.item_name.localeCompare(b.item_name)
              )}
              id={2}
              itemId="ggs_class_rooms"
              open={true}
              handleFilter={filterItems}
            />
          )}
          {studio.length > 0 && (
            <AccordionItemFilter
              key={3}
              index={3}
              title="Studio"
              items={studio.sort((a, b) =>
                a.item_name.localeCompare(b.item_name)
              )}
              id={3}
              itemId="ggs_studios"
              open={true}
              handleFilter={filterItems}
            />
          )}
        </ul>
      </div>
      <div
        className="js-off-canvas-overlay is-overlay-fixed"
        onClick={() => CloseFilters()}
      ></div>
    </div>
  );
}
